// eslint-ignore
export default 
`<template>
  <div>
    <b-button variant="primary" @click="openSplashMessage('primary')">Primary Splash Message</b-button>
    <b-button variant="success" @click="openSplashMessage('success')">Success Splash Message</b-button>
    <b-button variant="warning" @click="openSplashMessage('warning')">Warning Splash Message</b-button>
    <b-button variant="danger" @click="openSplashMessage('danger')">Danger Splash Message</b-button>
    <DttSplashMessage ref='splashMessage'/>
  </div>
</template>

<script>
import DttSplashMessage from '@bit/dtt.uic.dtt-splash-message'

export default {
  components: { DttSplashMessage },
  methods: {
    openSplashMessage (variant) {
      if (variant === 'primary') {
        this.$refs.splashMessage.show({title: 'Info Box', description: 'Description of what the info is all about.', variant: 'primary'})
      } else if (variant === 'success') {
        this.$refs.splashMessage.show({title: 'Success!', description: 'Description of what just happened.', variant: 'success'})
      } else if (variant === 'warning') {
        this.$refs.splashMessage.show({title: 'Warning', description: 'Description of what the warning is.', variant: 'warning'})
      } else {
        this.$refs.splashMessage.show({title: 'Error!', description: 'Something went wrong.', variant: 'danger'})
      }
    }
  }
}
</script>`;